import {
  EuiButtonEmpty,
  EuiContextMenu,
  type EuiContextMenuPanelDescriptor,
  EuiPopover,
  EuiText,
  EuiThemeProvider,
  EuiFlexGroup,
  EuiFlexItem,
  EuiAvatar,
} from '@elastic/eui';
import { useAnalytics } from '@lib/hooks/useAnalytics';
import { useSession, signOut } from 'next-auth/react';
import { FunctionComponent, useState } from 'react';

export const UserBadge: FunctionComponent = () => {
  const [isPopoverOpen, setPopover] = useState(false);
  const { data: session, status } = useSession();
  const { trackUserLogout } = useAnalytics();

  const closePopover = () => {
    setPopover(false);
  };

  const panels: EuiContextMenuPanelDescriptor[] = [
    {
      id: 0,
      items: [
        {
          name: 'My DA profile',
          icon: 'user',
          href: 'https://my.da.org.za/profile',
          target: '_blank',
        },
        {
          name: 'Sign out',
          icon: 'exit',
          onClick: () => {
            closePopover();
            trackUserLogout();
            signOut({ callbackUrl: 'https://login.voteda.org/logout' });
            // signOut();
          },
        },
      ],
    },
  ];

  if (process.env.NEXT_PUBLIC_VERSION != null) {
    panels[0].items.push({
      isSeparator: true,
      key: 'version-separator',
    });
    panels[0].items.push({
      name: `Version: ${process.env.NEXT_PUBLIC_VERSION}`,
      disabled: true,
      css: { textAlign: 'right' },
    });
  }

  if (status === 'authenticated') {
    const badge = (
      <EuiThemeProvider colorMode="dark">
        <EuiButtonEmpty
          iconType="arrowDown"
          size="xs"
          color="text"
          css={{ padding: '0 6px' }}
          iconSide="right"
          onClick={() => setPopover(true)}>
          <EuiFlexGroup responsive={false} alignItems="center" gutterSize="s">
            <EuiFlexItem grow={false}>
              {session.user.image != null ? (
                <EuiAvatar
                  imageUrl={session.user.image}
                  size="s"
                  name={session.user.name}
                />
              ) : (
                <EuiAvatar size="s" name={session.user.name} />
              )}
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
              <EuiText size="xs">
                <strong>{session.user.name}</strong> ({session.user.darn})
              </EuiText>
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiButtonEmpty>
      </EuiThemeProvider>
    );

    return (
      <EuiPopover
        button={badge}
        isOpen={isPopoverOpen}
        closePopover={closePopover}
        panelPaddingSize="none"
        anchorPosition="downRight">
        <EuiContextMenu initialPanelId={0} panels={panels} size="s" />
      </EuiPopover>
    );
  }

  return null;
};
